import { FaHiking, FaCampground, FaTree, FaUsers } from "react-icons/fa";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Experience the Adventure with Us",
    description: [
        "At our outdoor adventure club, we've been dedicated to providing exceptional hiking, camping, and trekking experiences for over two decades. Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "Our mission is to create memorable adventures that connect you with nature and inspire a lifelong love for the outdoors."
    ],
    points: [
        { 
            icon: <FaHiking />,
            title: "Experienced Guides",
        },
        { 
            icon: <FaCampground />,
            title: "Beautiful Campsites",
        },
        { 
            icon: <FaTree />,
            title: "Safe and Scenic Trails",
        },
        { 
            icon: <FaUsers />,
            title: "Community of Enthusiasts",
        }
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        alt1: "About-Image1",
        alt2: "About-Image2",
        alt3: "About-Image3",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;
